import React, { useEffect } from 'react';
import "../../stepper.css";
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';


const StaffPagination = ({ currentPage, handlePageClick, handleNextClick,  getPageNumbers, totalPages, Data, ButtonKey }) => {
    const details = useSelector((state) => state.details.details);
    const lastCompletedStep = details?.result?.lastCompletedStep;
    const location = useLocation();
    const route = location.pathname.split('/').pop();
    useEffect(() => {
        console.log(route)
    }, [])
    
    return (
        <>
         <nav className="flex justify-between">
                        <ul className="flex space-x-4 mt-5">
                          <li className={`prev ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}>
                            {currentPage === 1 ? <>   <a className='px-4 py-2 text-gray-700 border border-gray-300 rounded-md'>
                              &lt; previous
                            </a></> : <>
                              <a href="#" className='px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50' onClick={() => handlePageClick(currentPage - 1)}>
                                &lt; previous
                              </a>
                            </>}
                          </li>
                          {/* <li>
                            <div className='flex'> */}
                          {getPageNumbers().map((pageNumber, index) => (
                            <div
                              key={ButtonKey + index}
                              style={{ marginTop: '-8px' }}
                              className={`text-gray-700 border rounded-md hover:bg-gray-50`}
                            >
                              {pageNumber}
                            </div>
                          ))}
                          {/* </div>
                          </li> */}

                          <li className={`next ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}>
                            {currentPage === totalPages ?<>
                            <a 
                              rel="customerList"
                              className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
                               
                            >
                              next &gt;
                            </a>
                            </>:<>
                            <a
                              href="#"
                              onClick={handleNextClick}
                              rel="customerList"
                              className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50"
                              
                            >
                              next &gt;
                            </a>
                            </>}
                            
                          </li>
                        </ul>
                        <p className='mt-3'>
                          Page {currentPage} of {totalPages}, Total Records{' '}
                          {Data?.result?.pagedInfo?.totalRecords || 0}
                        </p>
                      </nav>
        </>
    );
}

export default StaffPagination;
